import {css} from 'lit';
export const styles = css`:host {
  --border-radius: 4px;
  --font: var(--gray-new-900);

  display: block;
  position: relative;
  font-size: var(--bu-font-size-sm);
}

a {
  --background: var(--blue-new-000);

  display: flex;
  align-items: flex-start;
  padding: 16px 12px 16px 36px;
  background-color: var(--background);
  color: var(--font);
  text-decoration: none;
  border-radius: var(--border-radius);
}

ef-avatar {
  margin-top: 2px;
  margin-right: 12px;
}

ef-timeago {
  display: flex;
}

.status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  position: absolute;
  top: 32px;
  left: 14px;
  background-color: var(--secondary-new-500);
}

.info {
  margin-right: 36px;
}

.date {
  margin-top: 2px;
  font-size: 12px;
}

slot:not([name])::slotted(:first-child) {
    margin: 0 0 2px !important;
  }

@media (min-width: 768px) {

slot:not([name])::slotted(:first-child) {
      font-size: var(--bu-font-size-sm) !important
  }
    }

slot[name='menu']::slotted(bu-notification-menu) {
  position: absolute;
  top: 16px;
  right: 12px;
}

a.read {
  --background: var(--contrast-light);
}

a.permanent {
  --background: var(--primary-500);
  --font: var(--primary-000);

  color: var(--contrast-light);
}

.permanent ~ slot[name='menu']::slotted(bu-notification-menu) {
  --dark-text: var(--contrast-light);
}

@media (hover: hover) {
  a:hover {
    --link-text-hover: var(--font);
  }
}

a:active {
  --background: var(--blue-new-100);
  --link-text-active: var(--font);
}

a.read:active {
  --background: var(--gray-new-000);
}

:host .permanent:active {
  --background: var(--primary-700);
  --link-text-active: var(--contrast-light);
}
`;
export default styles;
